module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av613-ba95ba72dde622d2998486b5a2fd84c7.jpg";